import React from "react";
import { Link } from "react-router-dom";
import styles from "./Article.module.css";

const ArticleCard = ({ title, route, introduction, image, publishedDate, author }) => {
  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleDateString('he-IL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Truncate introduction for card preview
  const truncateText = (text, maxLength = 120) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + '...';
  };

  return (
    <div className={styles.articleCard}>
      {image && (
        <div className={styles.articleImageWrapper}>
          <img 
            src={image} 
            alt={title} 
            className={styles.articleImage}
            loading="lazy"
          />
          <div className={styles.imageOverlay}></div>
        </div>
      )}
      <div className={styles.articleCardBody}>
        {publishedDate && (
          <div className={styles.articleMeta}>
            <span className={styles.articleDate}>
              {formatDate(publishedDate)}
            </span>
            {author && (
              <span className={styles.articleAuthor}>
                • {author}
              </span>
            )}
          </div>
        )}
        <h3 className={styles.articleTitle}>{title}</h3>
        <p className={styles.articleIntro}>
          {truncateText(introduction)}
        </p>
        <Link
          to={`/article/${route}`}
          className={styles.readMoreBtn}
        >
          קרא עוד
          <span className={styles.arrowIcon}>←</span>
        </Link>
      </div>
    </div>
  );
};

export default ArticleCard;
